import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const STACK_WEBHOOKS_TABLE_STORAGE_KEY = "stackSettingsWebhooksTable";
export const STACK_WEBHOOKS_TABLE_FILTERS_STORAGE_KEY = "stackSettingsWebhooksFilters";

export enum STACK_WEBHOOKS_COLUMN_ID {
  ENDPOINT = "ENDPOINT",
  STATUS = "STATUS",
  CREATED_AT = "CREATED_AT",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 1200;

export const STACK_WEBHOOKS_TABLE_COLUMNS_CONFIG: Record<
  STACK_WEBHOOKS_COLUMN_ID,
  TableColumnMeta
> = {
  [STACK_WEBHOOKS_COLUMN_ID.ENDPOINT]: {
    id: STACK_WEBHOOKS_COLUMN_ID.ENDPOINT,
    title: "Endpoint",
    minWidth: 150,
    defaultWidth: 400,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: false,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [STACK_WEBHOOKS_COLUMN_ID.STATUS]: {
    id: STACK_WEBHOOKS_COLUMN_ID.STATUS,
    title: "Enabled",
    minWidth: 112,
    defaultWidth: 140,
    maxWidth: 200,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [STACK_WEBHOOKS_COLUMN_ID.CREATED_AT]: {
    id: STACK_WEBHOOKS_COLUMN_ID.CREATED_AT,
    title: "Created at",
    minWidth: 120,
    defaultWidth: 180,
    maxWidth: 240,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [STACK_WEBHOOKS_COLUMN_ID.DROPDOWN]: {
    id: STACK_WEBHOOKS_COLUMN_ID.DROPDOWN,
    title: "Webhook actions",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    resizable: false,
    allowsSorting: false,
    canHide: false,
    canPin: false,
    canMove: false,
    configurable: false,
  },
};

export const SORT_CONFIG = {
  [STACK_WEBHOOKS_COLUMN_ID.ENDPOINT]: "endpoint",
  [STACK_WEBHOOKS_COLUMN_ID.STATUS]: "enabled",
  [STACK_WEBHOOKS_COLUMN_ID.CREATED_AT]: "createdAt",
};

export const INITIAL_SORT_OPTION = SORT_CONFIG[STACK_WEBHOOKS_COLUMN_ID.CREATED_AT];
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Desc;
